import { CTA_TYPE_OPTIONS } from '@/common/constants';
import { CTAProp, CTAType } from '@/common/types';
import classNames from 'classnames';
import React from 'react';
import { InlineCTA } from './InlineCTA';

import styles from './CTA.module.scss';

export interface CTAProps extends CTAProp {
  type?: CTAType;
  className?: string;
  dataHeapId?: string;
  showInverse?: boolean;
}

export const CTA: React.FC<CTAProps> = ({
  label,
  link,
  type = CTA_TYPE_OPTIONS.PRIMARY,
  className = '',
  dataHeapId,
  showInverse = false,
}) => {
  if (!label || !link) return null;

  const defaultHeapId = `mlp-webapp-cta-${type.toLowerCase()}-${label.toLowerCase().replace(/\s+/g, '-')}`;

  if (type.toLowerCase() === CTA_TYPE_OPTIONS.INLINE) {
    return (
      <InlineCTA label={label} link={link} dataHeapId={dataHeapId ? dataHeapId : defaultHeapId} />
    );
  }
  const styleClassName = classNames(
    styles['cta-btn'],
    styles[`cta-btn_type__${type.toLowerCase()}${showInverse ? '_inverse' : ''}`],
    className,
  );

  return (
    <a
      href={link}
      className={styleClassName}
      data-heap-id={dataHeapId ? dataHeapId : defaultHeapId}
    >
      {label}
    </a>
  );
};
